import { AxiosInstance, AxiosResponse } from 'axios'
import { convertInvoices } from '../deserializers/invoce'
import { Invoice } from '~/types/invoice'

export default function (instance: AxiosInstance) {
  const base = 'api/aspos/customer'

  return {
    async getInvoices(payload?: {
      limit?: number
      offset?: number
    }): Promise<Invoice[]> {
      const defaultParams = {
        limit: 50,
        offset: 0,
      }
      const params = Object.assign(defaultParams, payload)
      const { data } = await instance.get(`/${base}/invoices`, {
        params,
      })

      if (!data.Success) return []

      return convertInvoices(data.Invoices)
    },

    async downloadInvoice(id: number) {
      try {
        const response: AxiosResponse = await instance.get(
          `/${base}/invoice/download/${id}`,
          {
            responseType: 'blob',
          }
        )
        if (!response?.data) return null

        return URL.createObjectURL(response.data)
      } catch (error) {
        console.error(error)
        return null
      }
    },
  }
}
